import React, { useState } from 'react'
import Dialog from '@mui/material/Dialog'
import Typography from '@mui/material/Typography'
import DialogContent from '@mui/material/DialogContent'
import Switch from '@mui/material/Switch'
import Divider from '@mui/material/Divider'
import FormControlLabel from '@mui/material/FormControlLabel'

import { styled } from '@mui/material/styles';

const SpacedDiv = styled('div')({
    display: 'flex', 
    justifyContent: 'space-between',
    marginTop: '5px',
})

const H4 = styled('h4')({
    marginTop: '10px',
    marginBottom: '0px',
})

const StyledDivider = styled(Divider)({
    backgroundColor: '#fff',
    marginTop: '10px',
    marginBottom: '10px',
})

const JustifyTypography = styled(Typography)({
    textAlign: 'justify',
})

const LegalForm = (props) => {
    const [agreeThirdParty, setAgreeThirdParty] = useState(false)
    const [agreeTruthfulness, setAgreeTruthfulness] = useState(false)
    const [agreeDisclosure, setAgreeDisclosure] = useState(false)
    const [agreeMerjTerms, setAgreeMerjTerms] = useState(false)
    const [agreePrivacyPolicy, setAgreePrivacyPolicy] = useState(false)
    const [agreeDigtlTerms, setAgreeDigtlTerms] = useState(false)

    const hasAcceptedTerms = () => {
        if (
            !agreeThirdParty ||
            !agreeMerjTerms ||
            !agreeDisclosure ||
            !agreePrivacyPolicy ||
            !agreeDigtlTerms ||
            !agreeTruthfulness
        ) {
            return false
        }
        return true
    }

    const setValueOfAll = (value) => {
        setAgreeThirdParty(value)
        setAgreeTruthfulness(value)
        setAgreeDisclosure(value)
        setAgreeMerjTerms(value)
        setAgreePrivacyPolicy(value)
        setAgreeDigtlTerms(value)
        props.onSuccess()
    }

    const handleClose = () => {
        setValueOfAll(false)
        props.onCancel()
    }

    return (
        <Dialog
            open={props.show}
            onClose={handleClose}
            disableBackdropClick={true}
        >
            <DialogContent>
                <SpacedDiv>
                    <h2 className="title">
                        Legal Undertakings
                    </h2>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={hasAcceptedTerms()}
                                onChange={(e) =>
                                    setValueOfAll(!hasAcceptedTerms())
                                }
                                color="primary"
                                name="yesToAll"
                            />
                        }
                        label={<b>Accept All</b>}
                    />
                </SpacedDiv>
                <StyledDivider />
                <H4>MERJ</H4>
                <SpacedDiv>                        
                    <h4 className="ihq-blue">THIRD PARTY PERMISSION</h4>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={agreeThirdParty}
                                onChange={(e) => setAgreeThirdParty(!agreeThirdParty)}
                                color="primary"
                                name="agreeThirdParty"
                            />
                        }
                        label="Accept"
                    />
                </SpacedDiv>
                <JustifyTypography component="p" variant="body2">
                    I authorize MERJ or any relevant third party to obtain confirmation or additional information from an authorised bureau and is entitled to verify my details and that I am obliged to assist in such verification promptly when requested to do so.
                </JustifyTypography>
                <SpacedDiv>
                    <h4 className="ihq-blue">TRUTHFULNESS STATEMENT</h4>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={agreeTruthfulness}
                                onChange={(e) =>
                                    setAgreeTruthfulness(
                                        !agreeTruthfulness
                                    )
                                }
                                color="primary"
                                name="agreeTruthfulness"
                            />
                        }
                        label="Accept"
                    />
                </SpacedDiv>
                <JustifyTypography component="p" variant="body2">
                    I acknowledge that MERJ will rely on the truthfulness and completeness of the information provided.
                </JustifyTypography>
                <SpacedDiv>
                    <h4 className="ihq-blue">CONFIRMATION DISCLOSURE</h4>
                    <FormControlLabel
                    control={
                        <Switch
                            checked={agreeDisclosure}
                            onChange={(e) =>
                                setAgreeDisclosure(
                                    !agreeDisclosure
                                )
                            }
                            name="agreeDisclosure"
                            color="primary"
                        />
                    }
                    label="Accept"
                />
                </SpacedDiv>
                <JustifyTypography component="p" variant="body2">
                    By agreeing to be bound by the terms and conditions of the Application Form, you confirm that the details contained in this Application Form and in your supporting documents are true and correct. You will not be able to claim later that the details that you have included in this Application Form and in your supporting documents were not true and correct when you submitted this Application Form or the supporting documents. MERJ or other persons may also have claims and rights against you because of the details that you put in this Application Form AND PROVIDING FALSE INFORMATION COULD BE A CRIMINAL OFFENCE.
                </JustifyTypography>
                <SpacedDiv>
                    <h4 className="ihq-blue">MERJ TERMS & CONDITIONS</h4>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={agreeMerjTerms}
                                onChange={(e) => setAgreeMerjTerms(!agreeMerjTerms)}
                                name="agreeMerjTerms"
                                color="primary"
                            />
                        }
                        label="Accept"
                    />
                </SpacedDiv>
                <JustifyTypography component="p" variant="body2">
                    I hereby confirm that I have read, understood and accept all the aspects of MERJ Platform Participation Agreement and agree and undertake that I will be bound by all of the provisions of the
                    &nbsp;<a href="https://merj-files.s3-eu-west-1.amazonaws.com/MERJ+Platform+Participation+Agreement+v1.2.pdf" rel="noopener noreferrer" target="_blank" className="link no-decoration"><b>MERJ Terms and Conditions</b></a>&nbsp;
                    and that all the terms thereof will be enforceable against me by the relevant parties from such date of such acquisition.
                </JustifyTypography>
                <SpacedDiv>
                    <h4 className="ihq-blue">PRIVACY POLICY</h4>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={agreePrivacyPolicy}
                                onChange={(e) =>
                                    setAgreePrivacyPolicy(!agreePrivacyPolicy)
                                }
                                name="agreePrivacyPolicy"
                                color="primary"
                            />
                        }
                        label="Accept"
                    />
                </SpacedDiv>
                <JustifyTypography component="p" variant="body2">
                    I confirm that I have read, understood and accept all aspects of the
                    &nbsp;<a href="https://merj-files.s3-eu-west-1.amazonaws.com/Merj_Privacy_Policy.pdf" rel="noopener noreferrer" target="_blank" className="link no-decoration"><b>Privacy Policy</b></a>.
                </JustifyTypography>
                <StyledDivider />
                <SpacedDiv>
                    <Typography component="p" variant="body1">
                        <b>DIGTL <a href="https://digtl.co/terms" rel="noopener noreferrer" target="_blank" className="link no-decoration">Terms and Conditions</a></b>
                    </Typography>
                    <FormControlLabel
                        control={
                            <Switch
                                checked={agreeDigtlTerms}
                                onChange={(e) =>
                                    setAgreeDigtlTerms(!agreeDigtlTerms)
                                }
                                name="agreeDigtlTerms"
                                color="primary"
                            />
                        }
                        label="Accept"
                    />
                </SpacedDiv>
            </DialogContent>
        </Dialog>
    )
}

export default LegalForm
